import { Pipe, PipeTransform } from '@angular/core';
import { EventType, WebinarDTO } from '../models';

@Pipe({
    name: 'eventLabel',
    standalone: false
})
export class EventLabelPipe implements PipeTransform {

  public transform(webinar: WebinarDTO): string {
    switch (webinar?.baseType) {
      case EventType.IN_PERSON:
        return 'COMMON.in_person_event';
      case EventType.WEBINAR:
        return 'COMMON.webinar';
      default:
        return 'COMMON.event';
    }
  }
}
